<div [ngClass]="['sso-dialog', pageClass]">
  <div class="sso-content">
    <div class="sso-header">
      <div class="sso-title-wrapper">
        <img src="assets/logo2.svg" alt="logo" />
        <div class="sso-title">{{ title }}</div>
      </div>
    </div>
    <div class="sso-cancel-wrapper" [ngClass]="{ hide: noCancelSection }">
      <a
        [hidden]="!showCancel()"
        (click)="cancel($event)"
        href="#"
        data-automation="cancelLink"
        class="sso-cancel-choice"
        >{{ 'goBack' | i18n : 'sso-login' }}</a
      >
    </div>
    <div class="sso-body" [ngClass]="{ 'disable-width': disableWidthLimit, 'cover-page': coverPage }">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
